<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <material-card
      icon="mdi-format-list-numbered-rtl"
      icon-small
      title="گزارش وام های اعضا بر اساس تاریخ"
      color="accent"
      :loading="loading"
    >
      <v-row>
        <v-col
          cols="12"
          style="padding:0 40px 40px"
        >
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <div>
                <div>تاریخ شروع</div>
                <date-picker
                  ref="startDate"
                  v-model="startDate"
                  format="YYYY-MM-DDTHH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  :error-messages="errorMessages"
                  auto-submit
                  clearable
                />
                <div class="red--text">
                  {{ startDateValidatioin }}
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <div>
                <div>تاریخ پایان</div>
                <date-picker
                  ref="endDate"
                  v-model="endDate"
                  format="YYYY-MM-DDTHH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  :error-messages="errorMessages"
                  auto-submit
                  clearable
                />
                <div class="red--text">
                  {{ endDateValidatioin }}
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="4"
              style="text-align:left"
            >
              <v-btn
                color="primary"
                dark
                class="mx-1"
                @click="loadData"
              >
                دریافت اطلاعات
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
                single-line
                hide-details
                class="mb-5"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="500"
                :search="search"
                class="elevation-1"
              >
                <template v-slot:item="row">
                  <tr>
                    <td>
                      {{ row.item.firstName }}
                    </td>
                    <td>
                      {{ row.item.lastName }}
                    </td>
                    <td>
                      {{ row.item.personalCode }}
                    </td>
                    <td>
                      {{ row.item.title }}
                    </td>
                    <td class="text-center">
                      {{ row.item.amount.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.installment.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.startDate }}
                    </td>
                    <td class="text-center">
                      {{ row.item.installmentsCount }}
                    </td>
                    <td class="text-center">
                      {{ row.item.payed.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.remain.toString().toPriceFormat() }}
                    </td>
                    <td class="text-center">
                      {{ row.item.remainCount }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </material-card>
    <confirm-dlg ref="confirm" />
    <div class="py-3" />
  </v-container>
</template>

<script>
  import api from '@/util/app-api'
  import toast from '@/util/toast'
  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  export default {
    name: 'CheckoutThisMonth',
    components: {
      ConfirmDlg: () => import('@/components/Confirm'),
      'date-picker': VuePersianDatetimePicker,
    },
    data () {
      return {
        errorMessages: '',
        startDate: '',
        startDateValidatioin: '',
        endDateValidatioin: '',
        endDate: '',
        search: '',
        loading: false,
        headers: [
          {
            text: 'نام',
            align: 'start',
            sortable: true,
            value: 'firstName',
          }, {
            text: 'نام خانوادگی',
            align: 'start',
            sortable: true,
            value: 'lastName',
          }, {
            text: 'کد پرسنلی',
            align: 'center',
            sortable: true,
            value: 'personalCode',
          }, {
            text: 'عنوان وام',
            align: 'center',
            sortable: true,
            value: 'title',
          }, {
            text: 'مبلغ',
            align: 'center',
            sortable: true,
            value: 'amount',
          }, {
            text: 'قسط',
            align: 'center',
            sortable: true,
            value: 'installment',
          }, {
            text: 'تاریخ شروع',
            align: 'center',
            sortable: true,
            value: 'startDate',
          }, {
            text: 'تعداد اقساط',
            align: 'center',
            sortable: true,
            value: 'installmentsCount',
          }, {
            text: 'پرداخت شده',
            align: 'center',
            sortable: true,
            value: 'payed',
          }, {
            text: 'مانده',
            align: 'center',
            sortable: true,
            value: 'remain',
          }, {
            text: 'تعداد باقیمانده',
            align: 'center',
            sortable: true,
            value: 'remainCount',
          },
        ],
        items: [],
      }
    },
    mounted () {
    },
    methods: {
      loadData () {
        this.loading = true
        api.get('admin/report/MemberLoansByDate/?start=' + this.startDate + '&end=' + this.endDate, {})
          .then(
            response => {
              this.items = response
            })
          .catch(err => {
            toast.error(err.message)
          })
          .finally(x => { this.loading = false })
      },
    },
  }
</script>
<style>
</style>
